import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { Observable, Subscription } from "rxjs";
import { AuthGuard } from '../../_guards/auth.guard';
import { Client } from "../../_model/client-response/client";
import { FmSystemList } from "../../_model/fmSystemList-response/fmSystemList";
import { User } from '../../_model/user/user';
import { LoginStateService } from "../../pages/login/login-state.service";
import { AuthenticationService } from '../../service/authentication.service';
import { ClientService } from "../../service/client.service";
import { FmSystemListService } from "../../service/fmSystemList.service";
import { UserService } from "../../service/user.service";
import { ClientChooserComponent } from "./client-chooser/client-chooser.component";
import { FmSystemListChooserComponent } from "./fmSystemList-chooser/fmSystemList-chooser.component";
import { ClientStateService } from "./client-state.service";
import { FmSystemListStateService } from "./fmSystemList-state.service";
import { environment } from '../../../environments/environment';
import { BrandChooserComponent } from './brand-chooser/brand-chooser.component';
import { brandList } from '../../_model/brand/brand';
import { BrandService } from '../../service/brand.service';
import { BrandStateService } from './brand-state.service';
import { SnackbarService } from "../../service/snackbar.service";
import { FormControl, FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { CallbackFilterPipe } from '../../_pipes/callback-filter.pipe';
import { RouterModule } from '@angular/router';
import { Router, RouterLink } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
interface NavLink {
  path: string;
  label: string;
  filter: string; 
}

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  standalone: true,
  imports: [MatCardModule, MatTooltipModule, MatProgressSpinnerModule, 
    MatFormFieldModule, MatSelectModule, MatIconModule, CommonModule, 
    ReactiveFormsModule, MatMenuModule, CallbackFilterPipe , RouterModule, RouterLink, MatInputModule, MatButtonModule,
     MatAutocompleteModule, FormsModule, MatToolbarModule],
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {

  public navLinks: NavLink[] = [];
  public loading: boolean = false;
  public currentClient: any;
  public currentFmSystemList!: FmSystemList | undefined;
  public currentBrand!: brandList | undefined;

  public clients!: Client[];
  public fmSystemLists!: FmSystemList[];
  public activeLabel!: string;
  public brands!: brandList[];

  private subscriptions: Subscription = new Subscription();
  myControl = new FormControl('');
  filteredOptions!: Observable<any>;
  filteredDataToSearch: any[] = [];
  unfilteredDataToSearch: any[] = [];
  constructor(private authService: AuthenticationService,
              private clientService: ClientService,
              private router: Router,
              private brandService: BrandService,
              private fmSystemListService: FmSystemListService,
              private userService: UserService,
              public loginStateService: LoginStateService,
              private clientStateService: ClientStateService,
              private fmSystemListStateService: FmSystemListStateService,
              private dialog: MatDialog, private brandStateService: BrandStateService, private sbService: SnackbarService) {
  }

  public beComponentForm: FormGroup = new FormGroup({
    myControl: new FormControl("")
  });

  async ngOnInit() {
    this.navLinks = [
      {
        label: 'Work Orders',
        path: '/',
        filter: ''
      },
      {
        label: 'Visits',
        path: '/visits',
        filter: ''
      },
      {
        label: 'Customer Mapping',
        path: '/customer-mapping',
        filter: ''
      },
      {
        label: 'Stores',
        path: '/stores',
        filter: ''
      },
      {
        label: 'Report',
        path: '/report',
        filter: ''
      },
      {
        label: 'Reprocessing',
        path: '/reprocessing',
        filter: 'region'
      },      
      {
        label: 'FAQ',
        path: '/faq',
        filter: ''
      }
    ];

     this.initialiseBrandLists();
     this.initialiseFmSystemLists();
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith<string | Client | null>(''),
        map(value => {
          // Add a null check here before accessing properties
          if (value === null) {
            return null;
          }
          return typeof value === 'string' ? value : value.clientName;
        }),
        map(value => value ? this._filter(value) : this.clients)
      );
    this.subscriptions.add(this.loginStateService.loginStateChanged$.subscribe(loginStateChanged => {
      if (loginStateChanged) {
        this.initialiseFmSystemLists();
        this.initialiseBrandLists();
      }
    }));
    
    this.subscriptions.add(this.authService.returnUrl.subscribe((evt) => {
      const searchIndex = this.navLinks.findIndex((i) => i.path === evt);
      if(searchIndex >= 0){
        const activeLabel = this.navLinks[searchIndex].label;
        sessionStorage.setItem('activeLabel', JSON.stringify(activeLabel));
        localStorage.setItem('activeLabel', JSON.stringify(activeLabel));
        this.loginStateService.activeLabel = activeLabel;
      }
    }));

    const sessionValue = sessionStorage.getItem('activeLabel');
    const localValue = localStorage.getItem('activeLabel');

    this.loginStateService.activeLabel =
      (sessionValue ? JSON.parse(sessionValue) : null) ||
      (localValue ? JSON.parse(localValue) : null);
// console.log('Active Label:', this.loginStateService.activeLabel); 
      // this.loginStateService.activeLabel = JSON.parse(sessionStorage.getItem('activeLabel')) || JSON.parse(localStorage.getItem('activeLabel'));
  }

  initialiseClients() {
    if (this.isLoggedIn()) {
      this.loading = false;
      this.clientService.getClientsByFmsystemBrand().subscribe(response => {
          this.currentClient = response.data.find(c => c.clientId === this.userService.getClientId());
          // this.clients = response.data.filter(p => p.clientId !== this.userService.getClientId());
          this.clients = response.data;
          this.clients.sort((a,b) => a.clientName.localeCompare(b.clientName));
          this.loading = false;
          this.updateClientControlState();
        },
        () => this.loading = false);
    }
    // else{
    //   this.loading = true;
    // }
  }

  initialiseDynamicClients(){
    if (this.isLoggedIn()) {
      this.clientService.getClientsByFmsystemBrand().subscribe(response => {
          this.currentClient = response.data.find(c => c.clientId === this.userService.getClientId());
          // this.clients = response.data.filter(p => p.clientId !== this.userService.getClientId());
          this.clients = response.data;
          this.clients.sort((a,b) => a.clientName.localeCompare(b.clientName));
          this.updateClientControlState();
        });
    }
  }

  lookup(name: string): Client[] {    
    const filterValue = name.toLowerCase();
    return this.clients.filter(option => option.clientName.toLowerCase().includes(filterValue));

  }

  clean(t:any){
    t.value = '';
    this.lookup(t.value);
  }

  _handleKeydown(event: KeyboardEvent) {
    if (event.keyCode === 32) {
      event.stopPropagation();
    }
  }

  getDynamicClientsBy(fmSystem :string) : any {
        this.clientService.getDynamicClients(fmSystem).subscribe(response => {
            return response.data[0].clientId;
          });
    }

    async initialiseFmSystemLists() {
      if (this.isLoggedIn()) {
        this.loading = false;
        // console.log("hi")
        this.fmSystemListService.getFmSystemByDefaultBrands().subscribe(response => {
          // console.log("hi2",response)
            this.currentFmSystemList = response.data.find(c => c.fmSystemId === this.userService.getFmSystemId());
            this.fmSystemLists = response.data.filter(p => p.fmSystemId !== this.userService.getFmSystemId());
            this.initialiseDynamicClients();
            this.loading = false;
            return true;
          },
          // () => this.loading = true
          );
      }
    }

  isLoggedIn() {
    return AuthGuard.isLoggedIn();
  }
  initialiseDynamicClientsByBrandName(brand: string,fmSystemId: string){
    if (this.isLoggedIn()) {
      this.brandService.getClientsByBrandName(brand,fmSystemId).subscribe(response => {
        this.currentClient = response.data[0].clientId;
          this.clients = response.data.filter(p => p.clientId !== this.userService.getBrand());
          this.updateClientControlState();
        // this.currentClient = ((response.data.find(c=> c.clientId).clientId) === (this.userService.getClientId()));
        });   
    }
  }

async initialiseBrandLists() {
  if (this.isLoggedIn()) {
    this.loading = false;
    // console.log('Initialising Brand Lists');
    this.brandService.getBrandLists().subscribe(response => {
      // console.log('Brand Lists Response:', response);
      this.currentBrand = response.data.find(c => c.brand === this.userService.getBrand());
      this.brands = response.data.filter(p => p.brand !== this.userService.getBrand());

      // Add a null check here
      if (this.currentBrand && this.currentBrand.fmSystemListDTO) {
        this.currentFmSystemList = this.currentBrand.fmSystemListDTO.find(f => f.fmSystemId === this.userService.getFmSystemId());
        this.fmSystemLists = this.currentBrand.fmSystemListDTO.filter(f => f.fmSystemId !== this.userService.getFmSystemId());
      }
      
      this.initialiseFmSystemLists();
      this.initialiseDynamicClients();
      this.loading = false;
      return true;
    });
  }
}


  private _filter(name: string): Client[] {
   const filterValue = name.toLowerCase();
   return this.clients.filter(option => option.clientName.toLowerCase().includes(filterValue));
  }

open(evt: MouseEvent){
  this.filteredOptions = this.myControl.valueChanges
  .pipe(
    startWith<string | Client | null>(''),
    map(value => {
      // Add a null check before accessing properties
      if (value === null) {
        return null;
      }
      return typeof value === 'string' ? value : value.clientName;
    }),
    map(value => value ? this._filter(value) : this.clients)
  );
}

  isDisable = () => {
    if(this.clients && this.clients.length <= 1){
      return true;
    }
    else if(this.clients && this.clients.length>1){
      return false;  
    }
    else{
      return false;
    }
  }

  updateClientControlState() {
    const control = this.beComponentForm.get('myControl');
    if (this.isDisable()) {
      control?.disable();
    } else {
      control?.enable();
    }
  }

  // open(evt: MouseEvent): void {
  //     const target = new ElementRef(evt.currentTarget);
  //     const dialogRef = this.dialog.open(ClientChooserComponent, {
  //       minWidth: '150px',
  //       minHeight: '50px',
  //       maxHeight: '450px',
  //       data: {clients: this.clients, trigger: target}
  //     });
  //     dialogRef.afterClosed().subscribe(client => {
  //       if (client) {
  //         let user: User = this.userService.getUser();
  //         this.loading = true;
  //         this.userService.updateClient({brand: user.brand, email: user.email, defaultClientId: client.clientId, defaultFmSystemListId: user.fmSystemId}).subscribe(() => {
  //             user.clientId = client.clientId;
  //             this.userService.updateLocalUser(user);
  //             this.initialiseClients();
  //             this.clientStateService.clientStateChanged(true);
  //           },
  //           () => this.loading = false);
  //       }
  //     });
  // }
  displayFn(user?: Client): string | undefined {
    return user ? user.clientName : undefined;
  }



  selectedOption(evt: any,clientId: any) {
    if (evt && evt.isUserInput == true){
      let user: User = this.userService.getUser();
      this.loading = true;
      if (evt.source.viewValue){
        this.userService.updateClient({brand: user.brand, email: user.email, defaultClientId: clientId, defaultFmSystemListId: user.fmSystemId}).subscribe(() => {
          user.clientId = clientId;
          this.userService.updateLocalUser(user);
          this.initialiseClients();
          this.clientStateService.clientStateChanged(true);
        },
        () => this.loading = false);
      }
    }
  
  }

  openBrand(evt: MouseEvent): void {
    const target = new ElementRef(evt.currentTarget);
    const dialogRef = this.dialog.open(BrandChooserComponent, {
      minWidth: '150px',
      minHeight: '50px',
      maxHeight: '450px',
      data: {brands: this.brands, trigger: target}
    });
    dialogRef.afterClosed().subscribe(brand => {
      if (brand) {
        let user: User = this.userService.getUser();
        this.loading = true;
        this.fmSystemListService.getFmSystemByBrands(brand.brand).subscribe(clientRes => {
          if (clientRes.data.length > 0 && clientRes.data[0]!== null) {
            this.brandService.getClientsByBrandName(brand.brand,clientRes.data[0].fmSystemId).subscribe(response => {
              this.currentClient = response.data[0].clientId;
              this.clients = response.data.filter(p => p.clientId !== this.userService.getBrand());
              this.updateClientControlState();
              this.userService.updateFmSystemList({ email: user.email, defaultClientId: this.currentClient, defaultFmSystemListId: clientRes.data[0].fmSystemId, brand: brand.brand }).subscribe(() => {
                user.fmSystemId = clientRes.data[0].fmSystemId;
                user.clientId = this.currentClient;
                user.brand = brand.brand;
                this.userService.updateLocalUser(user);
                this.initialiseFmSystemLists();
                this.initialiseBrandLists();
                this.initialiseDynamicClients();
                // this.initialiseDynamicClientsByBrandName(brand.brand);
                this.clientStateService.clientStateChanged(true);
                this.fmSystemListStateService.fmSystemListStateChanged(true);
                this.brandStateService.brandStateChanged(true);
              },
                () => this.loading = false);
            });
          }
          else {
            this.sbService.openSnackBar(`There are no FM Systems/Customers available for the selected Brand  ` + brand.brand, 'Close');
            this.loading = false;
          }

        },
          () => this.loading = false);

      }
    });
  }


  filterNavigation(navItem: any) {
    if (navItem.filter !== '') {
      const filterKey = navItem.filter
       if(filterKey === 'region') {
          return environment.region !== 'ASIA' ? navItem : null
       }
    }
    return navItem;
  }

  activeRouter(link: any){
    this.loading = true;
    this.loginStateService.activeLabel = link.label;
    sessionStorage.setItem('activeLabel', JSON.stringify(this.loginStateService.activeLabel));
    localStorage.setItem('activeLabel', JSON.stringify(this.loginStateService.activeLabel));
    this.loading = false;
  }
  openFmSystemList(evt: MouseEvent): void {

    const target = new ElementRef(evt.currentTarget);
    const dialogRef = this.dialog.open(FmSystemListChooserComponent, {
      minWidth: '150px',
      minHeight: '50px',
      maxHeight: '450px',
      data: {fmSystemLists: this.fmSystemLists, trigger: target}
    });
    dialogRef.afterClosed().subscribe(fmSystemList => {
      if (fmSystemList) {
        let user: User = this.userService.getUser();
        this.loading = true;
          this.brandService.getClientsByBrandName(user.brand,fmSystemList.fmSystemId).subscribe(response => {
          this.currentClient = response.data[0].clientId;
          this.userService.updateFmSystemList({ email: user.email, defaultClientId: this.currentClient, defaultFmSystemListId: fmSystemList.fmSystemId, brand: user.brand }).subscribe(() => {
            user.fmSystemId = fmSystemList.fmSystemId;
            user.clientId = this.currentClient;
            this.userService.updateLocalUser(user);
            this.initialiseFmSystemLists();
            this.clientStateService.clientStateChanged(true);
            this.fmSystemListStateService.fmSystemListStateChanged(true);
          },
            () => this.loading = false);
          },()=>{
            this.loading = false;
        });
     }
    });
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}